import axios from 'axios';

export const encodeSVGs = async obj => {
  if (typeof obj !== 'object' || obj === null) {
    return;
  }

  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const value = obj[key];

      if (Array.isArray(value)) {
        // Recurse for each element in the array
        await Promise.all(value.map(encodeSVGs));
      } else if (typeof value === 'object') {
        // Recurse for the object
        await encodeSVGs(value);
      } else if (
        typeof value === 'string' &&
        value.includes('storyblok') &&
        value.endsWith('.svg')
      ) {
        // Encode the SVG to base64
        const response = await axios.get(value);
        const svgString = response.data;
        // Convert the SVG string to a base64 encoded string
        const buf = Buffer.from(svgString, 'utf8');
        const base64String = buf.toString('base64');
        obj[key] = 'data:image/svg+xml;base64,' + base64String;
      }
    }
  }
  return obj;
};
